import { render, staticRenderFns } from "./AdminCertificationList.vue?vue&type=template&id=48a3468a&"
import script from "./AdminCertificationList.vue?vue&type=script&lang=js&"
export * from "./AdminCertificationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports